export const PATH = "/assignees/query";
